import packageJson from '../package.json';

const normalizeRole = (role) => {
    if (!role) {
        return "";
    }
    return String(role).trim().toLowerCase();
};

// API URL from environment variable (set via .env file or build-time environment)
// Fallback to localhost for development if not set
const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:3002/api";

// Detect if we're in development mode based on NODE_ENV
const isDev = process.env.NODE_ENV !== 'production';

const config = {

    // Propriétés de configuration
    appName: "Mufyn",
    tenantName: "",
    logo: "",
    apiUrl: apiUrl,
    isDev: isDev,
    version: packageJson.version,
    displayPopup: false,
    myrole: "",
    roles: ["user", "license_owner", "admin"],
    superAdminEmail: "mufyn@nelx.net",
    myEmail: "",
    my_licence_url: "https://billing.nelx.net", // Lien pour gérer son abonnement
    playStoreUrl: "https://play.google.com/store/apps/details?id=net.nelx.mufyn.app",

    // Méthodes de configuration
    setTenantName: (name) => {
        config.tenantName = name;
    },
    setLogo: (logo) => {
        config.logo = logo;
    },
    setRole: (role) => {
        config.myrole = normalizeRole(role);
    },
    setEmail: (email) => {
        config.myEmail = String(email || "").trim().toLowerCase();
    },
    isSuperAdmin: () => {
        return config.myEmail === config.superAdminEmail;
    },
    role: (role, only = false) => {
        const userRole = normalizeRole(config.myrole);
        const requiredRole = normalizeRole(role);

        if (!requiredRole) {
            return true;
        }

        if (requiredRole === "super.admin") {
            return config.isSuperAdmin();
        }

        if (only) {
            return userRole === requiredRole;
        }

        const requiredRoleIndex = config.roles.indexOf(requiredRole);
        const userRoleIndex = config.roles.indexOf(userRole);

        if (requiredRoleIndex === -1) {
            return userRole === requiredRole;
        }

        if (userRoleIndex === -1) {
            return false;
        }

        if (config.isSuperAdmin()) {
            return true;
        }

        return userRoleIndex >= requiredRoleIndex;
    },
};

export default config;

